import { makeRequest } from 'utils/requestLogger';

export default (id) =>
    makeRequest('put', `/api/courses/${id}/read-messages/`);



// WEBPACK FOOTER //
// ./src/app/services/courses/readCourseMessages.js